module.exports = "<mat-form-field class=\"w-100-p\">\r\n  <mat-select [(ngModel)]=\"selectedCostOption\" placeholder=\"Cost Option\" name=\"costOption\"\r\n      (selectionChange)=\"costSelection()\" required>\r\n      <mat-option *ngFor=\"let option of costOptions\" [value]=\"option.value\">\r\n          {{option.viewValue}}\r\n      </mat-option>\r\n  </mat-select>\r\n</mat-form-field>\r\n"


//////////////////
// WEBPACK FOOTER
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/common/cost-option-dropdown/cost-option-dropdown.component.html
// module id = ../../../../../src/app/main/content/apps/common/cost-option-dropdown/cost-option-dropdown.component.html
// module chunks = main